import { ModalPbmObserver } from './modal-pbm.observer'
import { Observable } from 'rxjs'

export class ModalPbmComponent {
    constructor() {
        this.modalBtnElements = document.querySelectorAll('[data-modal="pbm"]');

        this.init();
    }

    init() {
        //Modal PBM Toggle Click
        //Event delegation strategy
        Observable
            .fromEvent(document.body, 'click', e => (
                {
                    event: e,
                    delegate: e.target.closest('[data-modal="pbm"]')
                }
            ))
            .filter(x => x.delegate !== null)
            .debounceTime(400)
            .do(event => this.closeAll())
            .map(event => this.buildPbmObj(event))
            .subscribe(new ModalPbmObserver());

        //Modal PBM Close
        //Event delegation strategy
        Observable
            .fromEvent(document.body, 'click', e => (
                {
                    event: e,
                    delegate: e.target.closest('[data-modal="close"]')
                }
            ))
            .filter(x => x.delegate !== null)
            .subscribe(() => this.closeAll());
    }

    closeAll() {
        const modals = document.querySelectorAll('.modal');
        if(modals) {
            Array.prototype.forEach.call(modals, modal => {
                modal.classList.remove('modal--active');
                document.body.classList.remove('block-scroll')
            });
        }
    }

    /**
     * Monta objeto com os dados do pbm baseado nos data atributtes no botao
     */
    buildPbmObj(event) {
        const target = event.delegate;

        return {
            step: target.getAttribute("data-pbm-step"),
            preco: target.getAttribute("data-pbm-preco"),
            item: target.getAttribute("data-pbm-item"),
            ean: target.getAttribute("data-pbm-ean"),
            descricao: target.getAttribute("data-pbm-descricao"),
            programaNome: target.getAttribute("data-pbm-programa-nome"),
            codigoPrograma: target.getAttribute("data-pbm-codigo-programa"),
            sequenciaPrograma: target.getAttribute("data-pbm-programa-sequencia"),
            codigoAdminConvenio: target.getAttribute("data-pbm-codigo-admin-convenio"),
            codigoConvenio: target.getAttribute("data-pbm-codigo-convenio"),
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-pbm/modal-pbm.component.js